import { FiX, FiStar, FiMapPin, FiUser } from "react-icons/fi"

function Stars({ rate }) {
    const r = Math.round(rate ?? 0)
    return (
        <div className="flex items-center gap-0.5">
            {[1, 2, 3, 4, 5].map((i) => (
                <FiStar
                    key={i}
                    className={
                        i <= r
                            ? "h-3.5 w-3.5 fill-cwfLanding text-cwfLanding"
                            : "h-3.5 w-3.5 text-muted-foreground/30"
                    }
                />
            ))}
            <span className="ml-1 text-xs font-medium text-foreground">{(rate ?? 0)}/5</span>
        </div>
    )
}

export function MatchModal({ isMatch, setIsMatch, matchResults }) {
    if (!isMatch) return null

    return (
        <div
            className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm animate-in fade-in duration-200"
            onClick={() => setIsMatch(false)}
        >
            <div
                className="flex max-h-[80vh] w-full max-w-lg flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-2xl animate-in zoom-in-95 slide-in-from-bottom-4 duration-200"
                onClick={(e) => e.stopPropagation()}
            >
                {/* En-tête */}
                <div className="flex items-center justify-between border-b border-border bg-gradient-to-r from-primary to-[#FFD133] px-5 py-4">
                    <div className="flex items-center gap-2.5">
                        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white/25">
                            <FiUser className="h-5 w-5 text-white" />
                        </div>
                        <div className="leading-tight">
                            <h3 className="font-poppins text-base font-semibold text-white">Professionnels trouvés</h3>
                            <p className="text-[11px] text-white/80">{matchResults.length} résultat(s)</p>
                        </div>
                    </div>
                    <button
                        onClick={() => setIsMatch(false)}
                        aria-label="Fermer"
                        className="flex h-8 w-8 items-center justify-center rounded-lg text-white/80 transition-colors hover:bg-white/20 hover:text-white"
                    >
                        <FiX className="h-5 w-5" />
                    </button>
                </div>

                {/* Résultats */}
                <div className="flex-1 space-y-3 overflow-y-auto p-4">
                    {matchResults.length === 0 ? (
                        <p className="py-8 text-center text-sm text-muted-foreground">Aucun résultat trouvé.</p>
                    ) : (
                        matchResults.map((person) => {
                            const score = Math.round(((person.final_score ?? 0)) * 100)
                            return (
                                <div
                                    key={person.id}
                                    className="rounded-xl border border-border bg-card p-4 shadow-sm transition-shadow hover:shadow-md"
                                >
                                    <div className="flex items-start gap-3">
                                        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary font-poppins text-base font-semibold text-white">
                                            {(person.firstname?.[0] ?? "?").toUpperCase()}{(person.lastname?.[0] ?? "?").toUpperCase()}
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <h4 className="truncate font-poppins text-sm font-semibold text-foreground">
                                                {person.firstname ?? "Inconnu"} {person.lastname ?? ""}
                                            </h4>
                                            <span className="mt-0.5 inline-flex items-center rounded-full bg-cwfGreen/15 px-2 py-0.5 text-xs font-medium text-cwfGreen">
                                                {person.job ?? "Non renseigné"}
                                            </span>
                                        </div>
                                        <div className="text-right">
                                            <p className="text-lg font-bold text-primary">{score}%</p>
                                            <p className="text-[10px] text-muted-foreground">match</p>
                                        </div>
                                    </div>

                                    <div className="mt-3 space-y-1 text-sm">
                                        <p className="text-muted-foreground">
                                            <span className="font-medium text-foreground">Spécialisation :</span>{" "}
                                            {person.speciality ?? "Non renseigné"}
                                        </p>
                                        <p className="flex items-center gap-1.5 text-muted-foreground">
                                            <FiMapPin className="h-3.5 w-3.5 shrink-0" />
                                            <span className="font-medium text-foreground">Localisation :</span>{" "}
                                            {person.sector ?? "Non renseigné"}
                                        </p>
                                        <p className="text-muted-foreground">
                                            <span className="font-medium text-foreground">Description :</span>{" "}
                                            {person.bio ?? "Non renseigné"}
                                        </p>
                                    </div>

                                    <div className="mt-3 flex items-center justify-between border-t border-border pt-3">
                                        <Stars rate={person.rates ?? 0} />
                                        <button className="rounded-full border border-primary px-4 py-1.5 text-xs font-medium text-primary transition-colors hover:bg-primary hover:text-white">
                                            Voir profil
                                        </button>
                                    </div>
                                </div>
                            )
                        })
                    )}
                </div>
            </div>
        </div>
    )
}